import { render, staticRenderFns } from "./SubContestLabel.vue?vue&type=template&id=158226fe&scoped=true&"
import script from "./SubContestLabel.vue?vue&type=script&lang=js&"
export * from "./SubContestLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158226fe",
  null
  
)

export default component.exports